import React from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import TextInput from '../../components/TextInput';
import ModalButtons from '../../components/Modal/ModalButtons';

const ResetPasswordModal = ({ data }) => {
	const {
		resetPasswordModalStatus,
		newPassword,
		setNewPassword,
		confirmPassword,
		setConfirmPassword,
		closeResetPasswordModal,
		handleResetPassword
	} = data;
	return (
		<Modal show={resetPasswordModalStatus.status}>
			<ModalHeading
				heading={`Reset Password ${resetPasswordModalStatus.data && resetPasswordModalStatus.data.length === 2
					? 'of ' + resetPasswordModalStatus.data[0]
					: ''} `}
				subHeading=''
			/>
			<ModalForm>
				<InputsSection style={{ alignItems: 'flex-start' }}>
					<TextInput
						type='password'
						icon='lock'
						label={`New Password`}
						placeholder={`New Password`}
						value={newPassword.value}
						// disabled={newUserFile.value !== ''}
						onChange={(e) => {
							setNewPassword({ value: e.target.value });
						}}
						errorMessage={newPassword.error}
					/>
				</InputsSection>
				<InputsSection style={{ alignItems: 'flex-start' }}>
					<TextInput
						type='password'
						icon='lock'
						label={`Confirm Password`}
						placeholder={`Confirm Password`}
						value={confirmPassword.value}
						// disabled={newUserFile.value !== ''}
						onChange={(e) => {
							setConfirmPassword({ value: e.target.value });
						}}
						errorMessage={confirmPassword.error}
					/>
				</InputsSection>
				<ModalButtons
					submitButtonLabel={`Reset Password`}
					onSubmit={handleResetPassword}
					cancelButtonLabel='Cancel'
					onCancel={closeResetPasswordModal}
				/>
			</ModalForm>
		</Modal>
	);
};

export default ResetPasswordModal;
